import { ArrayPropertyBuilderImpl } from './array-property-builder-impl';
export function arrayPropertyBuilder() {
    var defaultOptions = {};
    return function captureKey(name, selector, options) {
        if (options === void 0) { options = defaultOptions; }
        return createBuilder(name, selector, options);
    };
}
function createBuilder(name, selector, options) {
    if (selector === void 0) { selector = name; }
    var _a;
    return new ArrayPropertyBuilderImpl({
        name: name,
        properties: (_a = options.properties, (_a !== null && _a !== void 0 ? _a : [])),
        selector: selector,
    });
}
//# sourceMappingURL=array-property-builder-factory.js.map